import { Loader2, Send, X } from "lucide-react";

export const WelcomePreview = ({ preview, sending, onSend, onClose }) => (
  <div className="fixed inset-0 z-[70] flex items-start justify-center overflow-y-auto bg-black/80 p-4 backdrop-blur-sm sm:p-8" data-testid="welcome-preview-modal">
    <div className="w-full max-w-2xl border border-steel-border bg-steel-surface">
      <div className="flex items-center justify-between gap-4 border-b border-steel-border px-6 py-4">
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-steel-muted">Welcome email preview</p>
          <p className="mt-1 text-sm text-steel-text" data-testid="welcome-preview-subject">{preview.subject}</p>
        </div>
        <button
          type="button"
          data-testid="welcome-preview-close"
          onClick={onClose}
          aria-label="Close preview"
          className="flex h-8 w-8 shrink-0 items-center justify-center border border-steel-border text-steel-muted transition-colors hover:text-steel-text"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
      <iframe
        title="Welcome email preview"
        data-testid="welcome-preview-frame"
        srcDoc={preview.html}
        className="h-[55vh] w-full bg-white"
      />
      <div className="flex flex-wrap items-center justify-between gap-3 border-t border-steel-border px-6 py-4">
        <p className="text-xs text-steel-muted">
          The real temporary password is generated when you create the account.
        </p>
        <div className="flex gap-3">
          <button
            type="button"
            data-testid="welcome-preview-back"
            onClick={onClose}
            className="border border-steel-border px-5 py-2.5 text-sm text-steel-secondary transition-colors hover:text-steel-text"
          >
            Keep editing
          </button>
          <button
            type="button"
            data-testid="welcome-preview-send"
            onClick={onSend}
            disabled={sending}
            className="flex items-center gap-2 bg-steel-accent px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-steel-accentHover disabled:opacity-50"
          >
            {sending ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}
            {sending ? "Creating…" : "Create account & send"}
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default WelcomePreview;
